<template>
  <div class="branchoffice-select my-1">
    <div class="input-group input-group-sm branchoffice-input-group">
      <div class="input-group-prepend">
        <span class="input-group-text branchoffice-icon">
          <i class="bi bi-shop"></i>
        </span>
      </div>
      <q-select
        v-model="branchofficeId"
        :options="branchofficeOptions"
        class="branchoffice-form-select"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import QSelect from '@/components/shared/QSelect.vue';

export default {
  components: { QSelect },
  data: function () {
    return {
       branchofficeId: ''
    }
  },
  computed: {
    ...mapState('branchoffices',{
      branchoffices: state => state.branchoffices,
      selectedBranchofficeId: state => state.selectedBranchofficeId,
    }),
    branchofficeOptions() {
      return [
        { value: '', label: 'Todas las sucursales' },
        ...this.branchoffices.map(b => ({ value: b.id, label: b.name })),
      ];
    },
  },
 
  watch: {
    branchoffices () {
      this.branchofficeId = this.selectedBranchofficeId
    },
    selectedBranchofficeId(newValue)  {
      this.branchofficeId = newValue
    },
    branchofficeId: {
      handler: function (value) {
        this.$store.dispatch('branchoffices/setSelectedBranchofficeId', value)
      }
    }
  },
  created () {
    this.$store.dispatch('branchoffices/readSelectedBranchofficeId')
    this.$store.dispatch('branchoffices/getAllBranchoffices')
  }
};
</script>

<style scoped>
/* Las 5 subnavbars que usan este selector son ul.nav.d-flex; empujarlo con
   margin-left:auto lo deja pegado al borde derecho sin tocar cada navbar. */
.branchoffice-select {
  /* margin-left queda en auto (empuja a la derecha); el espacio visible
     respecto al item anterior se logra con padding, no con margin. */
  margin-left: auto;
  margin-right: 1rem;
  padding-left: 1rem;
}

/* El control vive siempre sobre el navbar azul oscuro, sea cual sea el tema
   de la app (no es dark mode: es el color de marca del navbar). El look
   claro de .input-group-text/.custom-select por defecto choca ahí, así que
   se pinta a mano "fantasma" (transparente, borde y texto claros). */
.branchoffice-icon {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.35);
  color: #fff;
}

.branchoffice-icon .bi {
  font-size: 0.875rem;
  line-height: 1;
}

/* QSelect no es hijo directo de .input-group, así que no recibe el
   flex-grow ni el radio-izquierdo-en-0 que Bootstrap aplica a .custom-select
   dentro de un input-group. Se replica a mano (valores de input-group-sm). */
.branchoffice-form-select {
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.branchoffice-form-select ::v-deep .qselect__trigger {
  height: calc(1.5em + 0.5rem + 2px);
  /* right bien amplio: ahí vive el ícono de flechita (bg-image de .custom-select),
     si no el texto largo lo tapa */
  padding: 0.25rem 1.75rem 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.35);
  color: #fff;
  /* mismo SVG que trae .custom-select por defecto, pero en blanco — el gris
     oscuro original es invisible sobre este fondo transparente/oscuro */
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3E%3Cpath fill='%23fff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E");
}

.branchoffice-form-select ::v-deep .qselect__trigger:disabled {
  color: rgba(255, 255, 255, 0.6);
}
</style>
